import React from 'react';
import { User } from '@ordermentum/ui-types';
import { connect } from 'react-redux';
import { RootState } from '../../redux/store';

type StateProps = {
  user: User;
};

const mapStateToProps = (state: RootState) => ({
  user: state?.profile?.data || {},
});

const ifLoggedIn = (
  LoggedIn: React.ComponentType<{ user: User }>,
  LoggedOut: React.ComponentType
) =>
  connect(mapStateToProps)((props: StateProps) => {
    const { user, ...rest } = props;
    if (user.email) {
      return <LoggedIn {...props} />;
    }
    return <LoggedOut {...rest} />;
  });

export default ifLoggedIn;
